import "./main.css";
import { EditorAppContainer } from "../src/editor-app";
import { h, render as preactRender } from "preact";

// const PREVIEW_HTML = require('./preview.html');
// const appProps = (window as any).__SHOW_UI_DATA__ || DEFAULT_PROPS;

const root = document.getElementById("root");

preactRender(
  <EditorAppContainer />,
  root
);
